import { MemberChecklistSideDrawer } from "@circle-react/components/MemberChecklist/MemberChecklistSideDrawer";

import { t } from "@/i18n-js/instance";
import { useMemberChecklist } from "@/react/components/MemberChecklist/hooks/useMemberChecklist";

import { HeaderIconButton } from "../HeaderIconButton";

const rootLocale = "header.member_checklist";

export const MemberChecklist = () => {
  const {
    shouldShowMemberChecklist,
    shouldShowMemberChecklistBadge,
    isMemberChecklistOpen,
    handleMemberChecklistOpenChange,
  } = useMemberChecklist();

  if (!shouldShowMemberChecklist) {
    return null;
  }

  return (
    <>
      <div className="relative">
        <HeaderIconButton
          icon="to-do-list"
          isOpen={isMemberChecklistOpen}
          onClick={() =>
            handleMemberChecklistOpenChange(!isMemberChecklistOpen)
          }
          ariaLabel={t([rootLocale, "title"])}
        />
        {shouldShowMemberChecklistBadge && (
          <span className="absolute right-1 top-1 size-2 rounded-full bg-c-sidebar-badge" />
        )}
      </div>
      <MemberChecklistSideDrawer
        open={isMemberChecklistOpen}
        onOpenChange={handleMemberChecklistOpenChange}
      />
    </>
  );
};
